import z from 'zod'

export const ImportFromFileSchema = z.object({
	product_diffs: z
		.array(
			z
				.instanceof(File)
				.refine(
					(file) =>
						['xlsx', 'xls', 'csv'].includes(file?.name?.split('.').pop() || ''),
					'Please provide a supported file type. (xlsx, xls, csv)'
				)
		)
		.min(1, 'Please provide a file'),
	ignore_empties: z.boolean(),
})
